/**
 * Single source of truth for the company's public contact details. Everything
 * the Contact page renders reads from this file.
 */
export const CONTACT_DETAILS = {
  addressLines: ['Resolute Property Solutions', 'Sindhu Bhavan', 'Ahmedabad, Gujarat', 'India'],
  phones: [{ label: 'Phone', value: '+91 97232 17777', href: 'tel:+919723217777' }],
  /** The agency's own RERA registration (distinct from each listing's own
   *  developer RERA number, shown on the property itself) — displayed in the
   *  site footer alongside its registered contact number. */
  rera: { number: 'AG/GJ/AHMEDABAD/AHMEDABAD CITY/AUDA/AA00913/300429R2', phone: '+91 97232 17777', phoneHref: 'tel:+919723217777' },
  email: 'ronak@resoluteproperty.in',
  /** WhatsApp business number in international format (digits only for the link). */
  whatsapp: { display: '+91 97232 17777', number: '919723217777' },
  hours: [
    { day: 'Monday – Saturday', time: '9:00 AM – 7:00 PM' },
    { day: 'Sunday', time: 'By appointment' },
  ],
  social: [
    { label: 'LinkedIn', href: 'https://www.linkedin.com/company/resolute-property-solutions-ahmedabad/' },
    { label: 'Instagram', href: 'https://www.instagram.com/resolutepropertysolutions' },
    { label: 'Facebook', href: 'https://www.facebook.com/share/1Bn14ir5Pz/' },
    { label: 'YouTube', href: 'https://www.youtube.com/@ResolutePropertySolutions' },
  ],
  /** Map location. `query` drives the embed + "Open in Maps" deep link (both
   *  geocode this text live, so it's always correct even without exact
   *  lat/lng). `lat`/`lng` are an approximate area-level estimate for Sindhu
   *  Bhavan, Ahmedabad — used only in the Contact page's JSON-LD; replace with
   *  the exact office coordinates once confirmed. */
  map: {
    query: 'Sindhu Bhavan, Ahmedabad, India',
    lat: 23.033,
    lng: 72.506,
    label: 'Resolute Property Solutions, Sindhu Bhavan, Ahmedabad',
  },
} as const;

/** Pre-filled WhatsApp deep link. */
export function whatsappHref(message = "Hi! I'd like to know more about your properties."): string {
  return `https://wa.me/${CONTACT_DETAILS.whatsapp.number}?text=${encodeURIComponent(message)}`;
}

/** Google Maps "Open in Maps" deep link (no API key required). */
export function mapsDirectionsHref(): string {
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
    CONTACT_DETAILS.map.query,
  )}`;
}

/** Keyless Google Maps embed URL (uses the public embed endpoint). */
export function mapsEmbedSrc(): string {
  return `https://www.google.com/maps?q=${encodeURIComponent(CONTACT_DETAILS.map.query)}&z=15&output=embed`;
}
